module.exports = __webpack_public_path__ + "img/025-Farewell.162e624e.svg";